import React from "react";

import { VISITTYPE } from "@/src/lib/util/config";

const PricingSection = ({ ISLOGGEDIN, visitType, currentTest }) => {
    const shouldShowPricing = !(
        (!ISLOGGEDIN && visitType === VISITTYPE.HOME) ||
        (ISLOGGEDIN && !currentTest?.mrp && !currentTest?.rate)
    );

    if (!shouldShowPricing) return null;

    const mrp = Number(currentTest?.mrp);
    const rate = Number(currentTest?.rate);
    const savingsPercent =
        mrp > 0 && rate > 0 && mrp > rate
            ? Math.round(((mrp - rate) / mrp) * 100)
            : 0;

    return (
        <div className="mt-5 flex items-end justify-between gap-3 rounded-lg bg-slate-50 px-4 py-3 ring-1 ring-slate-100">
            <div>
                <p className="text-xs font-medium text-slate-500">Price</p>
                <div className="mt-1 flex items-baseline gap-2">
                    {/* Rate Section */}
                    <h5 className="text-2xl font-bold leading-none text-slate-900">
                        ₹{currentTest?.rate}
                    </h5>

                    {/* MRP Section */}
                    <p className="text-sm leading-none text-slate-400 line-through">
                        ₹{currentTest?.mrp}
                    </p>
                </div>
            </div>

            {savingsPercent > 0 && (
                <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700 ring-1 ring-emerald-100">
                    {savingsPercent}% off
                </span>
            )}
        </div>
    );
};

export default PricingSection;
